export const remainingOuncesByPound = (
    pounds: number,
    minUnitOunces: number = 16
  ) => {
    return Math.abs((Math.trunc(pounds) - pounds) * minUnitOunces);
  };